var api = require("!../../../../style-loader@1.3.0-bcb747d9f4e0eb48bfe7/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader@5.2.7-5a859cb7cdcc3c736654/node_modules/css-loader/dist/cjs.js!./slick-theme.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};